import React, { createContext, useContext, useState, useEffect } from 'react';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Client, MessageDto } from '../DashboardApi/api';
import { REACT_APP_PORTAL_API_URL } from '../../KeyVariables';

interface NotificationsContextType {
  notifications: any[];
  notificationsCount: number;
  addNotification: (notification: MessageDto[], paggin: boolean) => void;
  removeAll: () => void;
  removeById: (id: number) => void;
}

const NotificationsContext = createContext<NotificationsContextType>({
  notifications: [],
  notificationsCount: 0,
  addNotification: () => { },
  removeAll: () => { },
  removeById: () => { },
});

export const NotificationsProvider = ({ children }) => {
  const [connection, setConnection] = useState<HubConnection | null>(null);
  const [notifications, setNotifications] = useState<MessageDto[]>([]);
  const [notificationsCount, setNotificationsCount] = useState<number>(0);

  const addNotification = (newNotifications: MessageDto[], paggin = false) => {
    setNotifications(prevNotifications => {
      const updatedNotifications = [...prevNotifications];
      newNotifications.forEach(newNotification => {
        if (!prevNotifications.some(notif => notif.id === newNotification.id)) {
          updatedNotifications.unshift(newNotification);
        }
      });
      updatedNotifications.sort((a, b) => a.id! - b.id!);
      return updatedNotifications;
    });
    if(!paggin) {
      setNotificationsCount(notificationsCount+newNotifications.length)
    }
  };

  useEffect(()=> {
    const apiUrl = REACT_APP_PORTAL_API_URL;
    const client = new Client(apiUrl);
    client.getnotificationscount().then((data) => {
      setNotificationsCount(data)
      if(data && data >0){
        client.getnotifications(1,5).then(res=>(setNotifications(res)))
      }
    });
  },[])

  const removeAll = () => {
    setNotifications([]);
    setNotificationsCount(0)
  };

  const removeById = (id: number) => {
    setNotifications(prevNotifications => prevNotifications.filter(notif => notif.id !== id));
    setNotificationsCount(notificationsCount-1)
  };



  return (
    <NotificationsContext.Provider value={{ notifications, notificationsCount, addNotification, removeAll, removeById }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationsContext);
